<template>
  <div class="box">
    <div class="head">
      <div class="left">
        <div class="tj1">第七届</div>
        <div class="tj2">CFCC智慧经济创新创业竞赛</div>
        <div class="tj3">股票交易个人赛</div>
      </div>
      <div class="right">
        <img src="@/assets/logo.png" alt="" />
      </div>
    </div>
    <div class="main">
      <div class="header">{{ title }}</div>
      <div class="slot" :style="{'padding-bottom':bottom + 'px','padding-top':top + 'px'}">
        <slot name="formList"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    top: {
      type: Number,
      default: 60
    },
    bottom: {
      type: Number,
      default: 60
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  max-width: 900px;
  margin: 60px auto 0;
  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 29px;
    .left {
      display: flex;
      color: #007ace;
      align-items: flex-end;
      .tj1 {
        width: 60px;
        height: 24px;
        text-align: center;
        border: 1px solid #007ace;
        margin-right: 9px;
        font-size: 16px;
        font-weight: 400;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      }
      .tj2 {
        margin-right: 18px;
        font-size: 24px;
        font-weight: 700;
        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
      }
      .tj3 {
        font-size: 16px;
        font-weight: 500;
        font-family: PingFang SC, PingFang SC-Medium;
      }
    }
    .right{
      img{
        width: 197px;
        height: 30px;
      }
    }
  }
  .main {
    max-width: 900px;
    background: #ffffff;
    border-radius: 8px;
    .header {
      height: 76px;
      background: #007ace;
      border-radius: 8px 8px 0px 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      color: #ffffff;
    }
    .slot {
      padding-top: 60px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
